// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2406":"457096bc","6154":"01d4fd2e","9281":"457096bc"}[chunkId] + ".chunk.css";
};